export default {
  billingType: {
    type: 'string',
    reuqired: true,
  },
  scheduleItems: {
    type: 'array',
    maxSize: 100,
    required: true,
    forEach: {
      type: 'object',
      properties: {
        itemType: {
          type: 'string',
          required: false,
        },
        milestoneName: {
          type: 'string',
          required: {
            value: true,
            when: {
              '$.itemType': {
                ne: 'CHANGE_REQUEST',
              },
            },
          },
          maxSize: 255,
        },
        milestoneType: {
          type: 'enum',
          required: {
            value: true,
            when: {
              '$.itemType': {
                ne: 'CHANGE_REQUEST',
              },
            },
          },
        },
        amount: {
          type: 'string',
          required: true,
        },
      },
    },
  },
};
